import { bool } from 'prop-types';
import classnames from 'classnames';
import styles from './Chevron.module.css';

const Chevron = (props: { toggled: boolean }) => {
  const { toggled } = props;
  const rootClx = classnames(styles.iconChevron, {
    [styles.iconChevronIsUp]: toggled,
    [styles.iconChevronIsDown]: !toggled,
  });
  return <div className={rootClx}></div>;
};

Chevron.propTypes = {
  toggled: bool,
};

export default Chevron;
